import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from "react";
import { UserActions, VendedorActions } from "src/features/admin-panel/PanelActions/enums";

interface Props {
    children: ReactNode;
}

export type Section = "Users" | "Vendedores";

export type AdminPanelUIConfig = {
    section: Section;
    setSection: Dispatch<SetStateAction<Section>>;
    setUserAction: Dispatch<SetStateAction<UserActions>>;
    userActions: UserActions;
    setVendedorAction: Dispatch<SetStateAction<VendedorActions>>;
    vendedorActions: VendedorActions;
}

export const AdminPanelUIContext = createContext<AdminPanelUIConfig | undefined>(undefined);

export const AdminPanelUIProvider = ({ children }: Props) => {
    const [section, setSection] = useState<Section>("Users");
    const [userActions, setUserAction] = useState<UserActions>(UserActions.UserList);
    const [vendedorActions, setVendedorAction] = useState<VendedorActions>(VendedorActions.VendedoresList);

    const value = useMemo<AdminPanelUIConfig>(() => {
        return {
            section,
            setSection,
            userActions,
            setUserAction,
            setVendedorAction,
            vendedorActions,
        };
    }, [section, userActions, vendedorActions]);

    return (
        <AdminPanelUIContext.Provider value={value}>
            {children}
        </AdminPanelUIContext.Provider>
    );
}
